import React from 'react';
import { Tooltip } from './ui/Tooltip';

/**
 * Move requirement icons — HOT, Hazmat, Overweight Permit, 93K/Triaxle
 * chassis, Swing, Tank, Reefer. Shared by At Risk Monitor's "Req" column and
 * the Dispatch Dashboard's synthetic "req" column.
 */
export interface RequirementFlags {
  hot?: string | null;
  hazmat?: string | null;
  overweightpermitrequired?: string | null;
  chassistype?: string | null;
  equiptype?: string | null;
  istank?: string | null;
  temperaturecontrolled?: string | null;
}

const RequirementIcons: React.FC<{ row: RequirementFlags }> = ({ row }) => {
  return (
    <div className="flex gap-1 items-center flex-wrap">
      {row.hot === 'Y' && (
        <Tooltip content="HOT Load" placement="top">
          <span className="gw-icon gw-icon-hotjar text-brand-red cursor-help" style={{ fontSize: '14px' }}></span>
        </Tooltip>
      )}
      {row.hazmat === 'Y' && (
        <Tooltip content="Hazmat Required" placement="top">
          <span className="flaticon flaticon-warning text-orange-500 cursor-help" style={{ fontSize: '14px' }}></span>
        </Tooltip>
      )}
      {row.overweightpermitrequired === 'Y' && (
        <Tooltip content="Overweight Permit" placement="top">
          <span className="flaticon flaticon-weight text-heading cursor-help" style={{ fontSize: '14px' }}></span>
        </Tooltip>
      )}
      {row.chassistype?.includes('93K') && (
        <Tooltip content="93K Triaxle Chassis" placement="top">
          <span className="gw-icon cursor-help text-heading" style={{ fontSize: '14px' }}>&#xE9E5;</span>
        </Tooltip>
      )}
      {!row.chassistype?.includes('93K') && row.chassistype?.toLowerCase().includes('triaxle') && (
        <Tooltip content="Triaxle Chassis" placement="top">
          <span className="gw-icon gw-icon-dual-axle text-blue-600 cursor-help" style={{ fontSize: '14px' }}></span>
        </Tooltip>
      )}
      {row.equiptype?.toLowerCase().includes('swing') && (
        <Tooltip content="Swing" placement="top">
          <span className="flaticon flaticon-cargo text-purple-600 cursor-help" style={{ fontSize: '16px' }}></span>
        </Tooltip>
      )}
      {row.istank === 'Y' && (
        <Tooltip content="Tank Endorsement" placement="top">
          <span className="flaticon flaticon-oil-tank text-purple-600 cursor-help" style={{ fontSize: '14px' }}></span>
        </Tooltip>
      )}
      {row.temperaturecontrolled === 'Y' && (
        <Tooltip content="Reefer" placement="top">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" className="text-blue-500 fill-current cursor-help">
            <path d="M11,24c-6.079.117-9.334-7.638-5-11.89V5c.211-6.609,9.791-6.6,10,0v7.11C20.335,16.363,17.077,24.117,11,24ZM11,2A3,3,0,0,0,8,5v7.537a1,1,0,0,1-.332.744A5.018,5.018,0,0,0,11,22a5.018,5.018,0,0,0,3.332-8.719A1,1,0,0,1,14,12.537V5A3,3,0,0,0,11,2Zm0,18a3.007,3.007,0,0,1-1-5.829V12a1,1,0,0,1,2,0v2.171A3.007,3.007,0,0,1,11,20Zm0-4a1,1,0,0,0,0,2A1,1,0,0,0,11,16ZM21,6a3,3,0,0,1,0-6A3,3,0,0,1,21,6Zm0-4a1,1,0,0,0,0,2A1,1,0,0,0,21,2Z"/>
          </svg>
        </Tooltip>
      )}
    </div>
  );
};

export default RequirementIcons;
